import React, { useEffect } from "react";
import { Button, Grid, H1, SystemMessage, Tag, Text } from "@shoptet/ui";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import googleImage from "../../assets/google-brand.svg";
import { WIZARD_STEP_PATH } from "../../constants/paths";
import { MetaLogo } from "../../elements/MetaLogo";
import WizardHeader from "../../elements/WizardHeader";
import {
  AdSystemStateT,
  useChangeGoogleAdsSettingsStateMutation,
  useChangeMetaAdsSettingsStateMutation,
  useOnboardingEnteredMutation,
} from "../../graphql/generated/graphql";

export const NewCampaignSelection = () => {
  const { t } = useTranslation("translation", { keyPrefix: "Wizard Campaign Selection Page" });
  const navigate = useNavigate();
  const [changeGoogleAdsSettingsState] = useChangeGoogleAdsSettingsStateMutation();
  const [changeMetaAdsSettingsState] = useChangeMetaAdsSettingsStateMutation();
  const [onboardingEntered] = useOnboardingEnteredMutation();

  useEffect(() => {
    onboardingEntered().catch(() => undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <WizardHeader />
      <H1>{t("Headline")}</H1>
      <div>
        <Text>{t("Page description line 1")}</Text>
      </div>
      <Text>
        <Trans components={{ b: <b /> }} i18nKey="Page description line 2" t={t} />
      </Text>
      <div style={{ marginTop: "24px" }}>
        <SystemMessage
          description={<Trans components={{ b: <b /> }} i18nKey="Recommendation description" t={t} />}
          level="notice"
          title={t("Recommendation title")}
        />
      </div>
      <div style={{ marginTop: "24px" }}>
        <Grid columns={2}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              background: "var(--app-surface-muted)",
              borderRadius: "var(--app-radius-box)",
              padding: "24px",
            }}
          >
            <div>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", height: "32px" }}>
                <img alt="google image" src={googleImage} style={{ maxWidth: "100px" }} />
                <Tag level="success" variant="primary">
                  {t("Recommended badge")}
                </Tag>
              </div>
              <div style={{ margin: "24px 0 20px" }}>
                <Text>{t("Google campaign description")}</Text>
              </div>
              <ul style={{ paddingLeft: "16px", marginBottom: "20px" }}>
                <li>
                  <Trans components={{ b: <b /> }} i18nKey="Google campaign feature 1" t={t} />
                </li>
                <li>
                  <Trans components={{ b: <b /> }} i18nKey="Google campaign feature 2" t={t} />
                </li>
              </ul>
              <div style={{ margin: "0 0 20px" }}>
                <Text>{t("Google campaign description footer")}</Text>
              </div>
            </div>
            <div>
              <Button
                size="md"
                variant="action"
                onClick={async () => {
                  await changeGoogleAdsSettingsState({ variables: { input: { state: AdSystemStateT.WizardT } } });
                  navigate(WIZARD_STEP_PATH.FIRST);
                }}
              >
                {t("Google campaign cta")}
              </Button>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              background: "var(--app-surface-muted)",
              borderRadius: "var(--app-radius-box)",
              padding: "24px",
            }}
          >
            <div>
              <div style={{ height: "32px" }}>
                <MetaLogo width={100} />
              </div>
              <div style={{ margin: "24px 0 20px" }}>
                <Text>{t("Meta campaign description")}</Text>
              </div>
              <ul style={{ paddingLeft: "16px", marginBottom: "20px" }}>
                <li>
                  <Trans components={{ b: <b /> }} i18nKey="Meta campaign feature 1" t={t} />
                </li>
                <li>
                  <Trans components={{ b: <b /> }} i18nKey="Meta campaign feature 2" t={t} />
                </li>
              </ul>
              <div style={{ margin: "0 0 20px" }}>
                <Text>{t("Meta campaign description footer")}</Text>
              </div>
            </div>
            <div>
              <Button
                size="md"
                variant="action"
                onClick={async () => {
                  await changeMetaAdsSettingsState({ variables: { input: { state: AdSystemStateT.WizardT } } });
                  navigate(WIZARD_STEP_PATH.META_FIRST);
                }}
              >
                {t("Meta campaign cta")}
              </Button>
            </div>
          </div>
        </Grid>
      </div>
    </div>
  );
};
